import router from '@/router'
import { startLoading, endLoading, endDomLoading } from '@/util/loading'
import store from '@/store'
import helper from '@/util/signinHelper'
import { getCookies, setCookies } from '@/util/cookies'
import { sensorsBindLogin } from '@/util/sensorsdata'
import { redirect } from '@/util/webview'
import {
  getAppUserInfoStorage,
} from '@/util/appUserInfoStorage'
export default {
  authorize() {
    router.beforeEach(async (to, from, next) => {
      const loginStatus = store.state.common.loginStatus
      const accessToken = to.query.accessToken;
      const device = to.query.device
      const appUserInfo = getAppUserInfoStorage()  || '{}';
      const query = to.query;
      if (query.racc) {
        setCookies('racc', query.racc);
        delete query.racc;
        next({ path: to.path, query });
      }
      if(query.atid) {
        setCookies('atid', query.atid);
        delete query.atid;
        next({ path: to.path, query });
      }

      if (device) {
        // 嵌入app端
        try {
          helper.loginByApp()
        } catch (error) {
          console.error('Failed to decrypt token:', error.message)
          redirect(501) // 退回app
        }
      } else if (accessToken) {
        if (appUserInfo.device) {
          try {
            helper.loginByApp()
          } catch (error) {
            console.error('Failed to decrypt token:', error.message)
            redirect(501) // 退回app
          }
        } else {
          try {
            helper.loginByToken(accessToken);
          } catch (error) {
            console.error('Failed to decrypt accessToken:', error.message);
            helper.signOut('logout')
          }
        }
      } else if (!loginStatus && !accessToken) helper.getCpUrl('logout')
      else if (loginStatus) {
        if (!getCookies('xtoken')) helper.signOut()
        else {
          sensorsBindLogin(store.state.common.userId, store.state.common.eventEmailId, store.state.common.eventMobileId)
          startLoading('router')
          next()
        }
      }
    })
    router.afterEach((to, from) => {
      endDomLoading(),
      endLoading()
    })
  },
}
